import { TooltipDesktop } from '@cian/ui-kit';

import * as styles from './KokonCertificate.css';
import { KokonTooltipContent } from '../KokonTooltipContent';

export const KokonCertificate = () => {
  return (
    <TooltipDesktop title={<KokonTooltipContent />} theme="white" placement="right-start">
      <div className={styles['icon']} data-name="KokonCertificate" />
    </TooltipDesktop>
  );
};
